import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { CreditScoreSliceType } from './types';

const initialState: CreditScoreSliceType = {
  history: null,
};

const creditScoreSlice = createAppSlice({
  name: 'creditScore',
  initialState,
  reducers: {
    setCreditScoreHistory: (
      state,
      action: PayloadAction<CreditScoreSliceType['history']>,
    ) => {
      state.history = action.payload;
    },
  },
});

export const { setCreditScoreHistory } = creditScoreSlice.actions;
export default creditScoreSlice.reducer;
